
export const Data = {
  yearly: [
    { id: 1, year: 2016, userGain: 80000, userLost: 823 },
    { id: 2, year: 2017, userGain: 45688, userLost: 345 },
    { id: 3, year: 2018, userGain: 78888, userLost: 555 },
    { id: 4, year: 2019, userGain: 90000, userLost: 4555 },
    { id: 5, year: 2020, userGain: 4300, userLost: 234 }
  ],
  monthly: [
    { id: 1, month: "Jan", userGain: 6700, userLost: 68 },
    { id: 2, month: "Feb", userGain: 7200, userLost: 55 },
    { id: 3, month: "Mar", userGain: 6900, userLost: 60 },
    { id: 4, month: "Apr", userGain: 8500, userLost: 75 },
    { id: 5, month: "May", userGain: 9100, userLost: 80 },
    { id: 6, month: "Jun", userGain: 7700, userLost: 65 },
    { id: 7, month: "Jul", userGain: 8800, userLost: 70 },
    { id: 8, month: "Aug", userGain: 9200, userLost: 85 },
    { id: 9, month: "Sep", userGain: 8600, userLost: 78 },
    { id: 10, month: "Oct", userGain: 8900, userLost: 82 },
    { id: 11, month: "Nov", userGain: 8700, userLost: 76 },
    { id: 12, month: "Dec", userGain: 9500, userLost: 88 }
  ],
  weekly: [
    { id: 1, week: "Week 1", userGain: 1800, userLost: 20 },
    { id: 2, week: "Week 2", userGain: 1900, userLost: 22 },
    { id: 3, week: "Week 3", userGain: 2100, userLost: 25 },
    { id: 4, week: "Week 4", userGain: 2000, userLost: 28 }
  ],
  daily: [
    { id: "2024-11-10", date: "2024-11-10", userGain: 350, userLost: 4 },
    { id: "2024-11-11", date: "2024-11-11", userGain: 400, userLost: 5 },
    { id: "2024-11-12", date: "2024-11-12", userGain: 370, userLost: 4 },
    { id: "2024-11-13", date: "2024-11-13", userGain: 380, userLost: 6 },
    { id: "2024-11-14", date: "2024-11-14", userGain: 390, userLost: 7 },
    { id: "2024-11-15", date: "2024-11-15", userGain: 360, userLost: 3 },
    { id: "2024-11-16", date: "2024-11-16", userGain: 340, userLost: 2 }
  ]
};



  export const TransactionData ={
    weekly: [
      { id: "monday", label: "Monday", value: 195, color: "hsl(90, 70%, 50%)" },
      { id: "tuesday", label: "Tuesday", value: 419, color: "hsl(56, 70%, 50%)" },
      { id: "wednesday", label: "Wednesday", value: 407, color: "hsl(103, 70%, 50%)" },
      { id: "thursday", label: "Thursday", value: 474, color: "hsl(186, 70%, 50%)" },
      { id: "friday", label: "Friday", value: 71, color: "hsl(104, 70%, 50%)" },
    ],
    monthly: [
      { id: "january", label: "January", value: 1200, color: "hsl(0, 70%, 50%)" },
      { id: "february", label: "February", value: 900, color: "hsl(30, 70%, 50%)" },
      { id: "march", label: "March", value: 1400, color: "hsl(60, 70%, 50%)" },
      { id: "april", label: "April", value: 1100, color: "hsl(90, 70%, 50%)" },
      { id: "may", label: "May", value: 1500, color: "hsl(120, 70%, 50%)" },
      { id: "june", label: "June", value: 1300, color: "hsl(150, 70%, 50%)" },
    ],
    yearly: [
      { id: "2020", label: "2020", value: 14000, color: "hsl(180, 70%, 50%)" },
      { id: "2021", label: "2021", value: 15000, color: "hsl(210, 70%, 50%)" },
      { id: "2022", label: "2022", value: 16000, color: "hsl(240, 70%, 50%)" },
      { id: "2023", label: "2023", value: 17000, color: "hsl(270, 70%, 50%)" },
    ],
  };
  export const TransactionData2 = {
    daily: [
      { id: "2024-11-20", label: "Nov 20", value: 195, color: "hsl(90, 70%, 50%)" },
      { id: "2024-11-21", label: "Nov 21", value: 419, color: "hsl(56, 70%, 50%)" },
      { id: "2024-11-22", label: "Nov 22", value: 407, color: "hsl(103, 70%, 50%)" },
      { id: "2024-11-23", label: "Nov 23", value: 474, color: "hsl(186, 70%, 50%)" },
      { id: "2024-11-24", label: "Nov 24", value: 71, color: "hsl(104, 70%, 50%)" },
    ],
    weekly: [
      { id: "week-1", label: "Week 1", value: 1500, color: "hsl(200, 70%, 50%)" },
      { id: "week-2", label: "Week 2", value: 2000, color: "hsl(220, 70%, 50%)" },
      { id: "week-3", label: "Week 3", value: 1700, color: "hsl(240, 70%, 50%)" },
      { id: "week-4", label: "Week 4", value: 1900, color: "hsl(260, 70%, 50%)" },
    ],
    monthly: [
      { id: "2024-01", label: "January", value: 1200, color: "hsl(0, 70%, 50%)" },
      { id: "2024-02", label: "February", value: 900, color: "hsl(30, 70%, 50%)" },
      { id: "2024-03", label: "March", value: 1400, color: "hsl(60, 70%, 50%)" },
      { id: "2024-04", label: "April", value: 1100, color: "hsl(90, 70%, 50%)" },
      { id: "2024-05", label: "May", value: 1500, color: "hsl(120, 70%, 50%)" },
      { id: "2024-06", label: "June", value: 1300, color: "hsl(150, 70%, 50%)" },
    ],
    yearly: [
      { id: "2020", label: "2020", value: 14000, color: "hsl(180, 70%, 50%)" },
      { id: "2021", label: "2021", value: 15000, color: "hsl(210, 70%, 50%)" },
      { id: "2022", label: "2022", value: 16000, color: "hsl(240, 70%, 50%)" },
      { id: "2023", label: "2023", value: 17000, color: "hsl(270, 70%, 50%)" },
    ],
  };
  